import React from 'react';
import { SvgIcon } from '@mui/material';

// Option 2: Simple Circle with "P" 
export const PlatformIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <text x="12" y="17" textAnchor="middle" fontSize="12" fontWeight="bold" fill="currentColor">P</text>
    </SvgIcon>
);

// Option 3: Membership Card Style
export const MemberCardIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <circle cx="8" cy="12" r="2" fill="currentColor" />
        <line x1="12" y1="10" x2="18" y2="10" stroke="currentColor" strokeWidth="1.5" />
        <line x1="12" y1="14" x2="16" y2="14" stroke="currentColor" strokeWidth="1.5" />
    </SvgIcon>
);

// Option 4: Community/Network Icon
export const NetworkIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <circle cx="12" cy="5" r="2" fill="currentColor" />
        <circle cx="6" cy="12" r="2" fill="currentColor" />
        <circle cx="18" cy="12" r="2" fill="currentColor" />
        <circle cx="9" cy="19" r="2" fill="currentColor" />
        <circle cx="15" cy="19" r="2" fill="currentColor" />
        <path d="M12 7L6 10M12 7L18 10M6 14L9 17M18 14L15 17" stroke="currentColor" strokeWidth="1.5" />
    </SvgIcon>
);

// Option 5: Shield with Checkmark (Security/Trust)
export const TrustIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
        />
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

// Option 6: Simple Geometric Logo
export const GeometricIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <polygon points="12,2 22,8.5 22,15.5 12,22 2,15.5 2,8.5" stroke="currentColor" strokeWidth="2" fill="none" />
        <circle cx="12" cy="12" r="4" fill="currentColor" />
    </SvgIcon>
);
